import { Link } from 'react-router-dom';
import { classifyAccuracy } from '../hooks/useGeolocation';

interface GpsAccuracyBannerProps {
  accuracyMeters: number | null | undefined;
}

export default function GpsAccuracyBanner({ accuracyMeters }: GpsAccuracyBannerProps) {
  const level = classifyAccuracy(accuracyMeters);

  if (level === 'good') return null;
  if (level === 'unknown' && accuracyMeters == null) return null;

  const isVeryWeak = level === 'very_weak';
  const containerClass = isVeryWeak
    ? 'rounded-lg bg-red-50 border border-red-200 p-3'
    : 'rounded-lg bg-amber-50 border border-amber-200 p-3';
  const iconClass = isVeryWeak ? 'text-red-600' : 'text-amber-600';
  const titleClass = isVeryWeak ? 'text-red-700' : 'text-amber-700';
  const bodyClass = isVeryWeak ? 'text-red-600' : 'text-amber-600';

  const title = isVeryWeak ? 'Very weak GPS signal' : 'Weak GPS signal';
  const body = isVeryWeak
    ? 'Your location may be wildly wrong. Distance to store cannot be trusted.'
    : 'Distance to store may be off. Try walking outside or check Precise Location.';

  const roundedAccuracy = accuracyMeters != null ? Math.round(accuracyMeters) : null;

  return (
    <div className={`flex items-start gap-2 ${containerClass}`}>
      <svg
        className={`mt-0.5 h-5 w-5 flex-shrink-0 ${iconClass}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
      <div className="flex-1">
        <p className={`text-sm font-medium ${titleClass}`}>
          {title}
          {roundedAccuracy != null && ` (~${roundedAccuracy}m)`}
        </p>
        <p className={`text-xs ${bodyClass}`}>{body}</p>
        <Link
          to="/help#troubleshooting"
          className={`mt-1 inline-block text-xs font-medium underline ${titleClass} hover:opacity-80`}
        >
          How to fix
        </Link>
      </div>
    </div>
  );
}
